import { render, staticRenderFns } from "./FundingRequestDeleted.vue?vue&type=template&id=196b5da7&scoped=true&"
import script from "./FundingRequestDeleted.vue?vue&type=script&lang=js&"
export * from "./FundingRequestDeleted.vue?vue&type=script&lang=js&"
import style0 from "./FundingRequestDeleted.vue?vue&type=style&index=0&id=196b5da7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "196b5da7",
  null
  
)

export default component.exports